var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import styles from "../styles/LicenseForm.module.css";
import NavigationButton from "./navigation-button";
import licenseplateValidator from "../lib/validation/licenseplate";
export function Form(_a) {
    var onResponse = _a.onResponse, baseUrl = _a.baseUrl;
    var _b = useState(null), errorMessage = _b[0], setErrorMessage = _b[1];
    return (_jsx(Formik, { validateOnChange: false, validateOnBlur: false, onSubmit: function (values, bag) {
            return __awaiter(this, void 0, void 0, function () {
                var res, data, error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            (_a = window.umami) === null || _a === void 0 ? void 0 : _a.track("check-kenteken");
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 6, 7, 8]);
                            return [4 /*yield*/, fetch("".concat(baseUrl, "/api/check/").concat(values.licenseplate))];
                        case 2:
                            res = _b.sent();
                            if (!(res.status === 404)) return [3 /*break*/, 3];
                            setErrorMessage("Kenteken niet gevonden");
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, res.json()];
                        case 4:
                            data = _b.sent();
                            onResponse(data);
                            _b.label = 5;
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            error_1 = _b.sent();
                            console.error("Er ging iets mis: ", error_1);
                            onResponse(null);
                            return [3 /*break*/, 8];
                        case 7:
                            bag.setSubmitting(false);
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        }, initialValues: {
            licenseplate: "",
        }, validationSchema: yup.object({
            licenseplate: licenseplateValidator,
        }), children: function (form) {
            var _a, _b;
            return (_jsxs("form", { onSubmit: form.handleSubmit, children: [_jsxs("div", { className: styles.licenseForm, children: [_jsxs("div", { className: styles.licensePlateInputFieldContainer, children: [_jsxs("p", { className: styles.countryCodePart, children: [_jsx("img", { alt: "", src: "".concat(baseUrl, "/images/eu.svg"), width: 16, height: 16 }), _jsx("span", { children: "NL" })] }), _jsx("input", { name: "licenseplate", "aria-label": "Kenteken", maxLength: 8, className: styles.licensePlateInputField, onChange: function (e) {
                                            setErrorMessage(null);
                                            form.handleChange(e);
                                        }, onBlur: form.handleBlur })] }), _jsx(NavigationButton, { showLoading: form.isSubmitting, text: "Check dit kenteken", disabled: form.isSubmitting, type: "submit", baseUrl: baseUrl })] }), errorMessage ||
                        (((_a = form === null || form === void 0 ? void 0 : form.errors) === null || _a === void 0 ? void 0 : _a.licenseplate) && (_jsx("span", { className: styles.formErrorMessage, children: errorMessage || ((_b = form === null || form === void 0 ? void 0 : form.errors) === null || _b === void 0 ? void 0 : _b.licenseplate) })))] }));
        } }));
}
